import Card from "../../components/UI/Card";
import React, {useEffect, useState} from "react";
import TabComponent from "../../components/UI/TabComponent";
import {getOrderTypes} from "../../api/orders";
import {useDispatch} from "react-redux";
import {setActiveTab, setOrderTypes} from "../../store/slices/orderSlice";
import OrdersListComponent from "../../views/orders/OrdersListComponent";
import {useLoaderData} from "react-router-dom";

export async function loader({params}){
  const [ orderType] = await Promise.all([
    getOrderTypes(params.id)
  ]);

  return { orderType};
}

const VendorOrderList = () =>{
  const {vendor, orderType} = useLoaderData();

  const dispatch = useDispatch()
  const [tabItems, setTabItems] = useState([
    {
      id: "all",
      title: "All Orders",
      component: <OrdersListComponent orderTypes={orderType} />
    }
  ])


  useEffect(()=>{
    if(orderType){
      let types = [];
      Object.keys(orderType).forEach(key => {
        types.push(orderType[key])
        setTabItems(tabItems => [...tabItems, {id:orderType[key].id, title: orderType[key].type,  component: <OrdersListComponent orderTypes={orderType} /> }])
      });
      dispatch(setOrderTypes(types))
    }
  }, [ ])

  const tabChangeEvent = (activeTab) => {
    dispatch(setActiveTab(activeTab))
  }

  return (
    <>
      <Card title={'Orders'}>
        <TabComponent items={tabItems} tabChangeEvent={tabChangeEvent} classes={'pl_0 pr_0 pt_0 border_none'} />
      </Card>
    </>
  );
}

export default VendorOrderList